var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 5.5C5.21624 5.5 3.5 7.21624 3.5 9.33333V30.0282C3.5 31.7615 4.90514 33.1667 6.63847 33.1667H31.407C33.3603 33.1667 35.0012 31.698 35.2169 29.7566L36.1428 21.4233C36.2632 20.3396 35.9164 19.2559 35.1893 18.4435C34.9827 18.2126 34.7509 18.0099 34.5 17.838V14.3333C34.5 12.2162 32.7838 10.5 30.6667 10.5H19.95C19.5638 10.5 19.2027 10.3089 18.9854 9.98961L18.9854 9.9896L16.5757 6.44796L16.5757 6.44793C16.1722 5.85492 15.5015 5.49999 14.7843 5.5H7.33333ZM32.3329 17.1667C32.7332 17.1667 33.1265 17.2292 33.5 17.3486V14.3333C33.5 12.7685 32.2315 11.5 30.6667 11.5H19.95C19.2328 11.5 18.5621 11.1451 18.1586 10.5521L18.1586 10.5521L15.7489 7.01047L15.7489 7.01044C15.5317 6.69112 15.1705 6.5 14.7843 6.5H7.33333C5.76853 6.5 4.5 7.76853 4.5 9.33333V30.0282C4.5 31.2092 5.45742 32.1667 6.63847 32.1667C7.72811 32.1667 8.64351 31.3473 8.76384 30.2644L9.84026 20.5767C10.056 18.6354 11.6969 17.1667 13.6502 17.1667H32.3329Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;